export const ASSET_INVENTORY = {
    ACCESS_DENIED: 'You currently do not have access to any menu options. Please contact your administrator for access.',
    ASSET_INVENTORY_TRAINING: 1,
    ASSET_INVENTORY_APP_AREA_NAME: 'AssetInventoryAdmin',
    ACCESS_DENIED_M_AND_A_SCAN: 'You currently do not have access to M and A Scan menu. Please contact your administrator for access.'
}